/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Create_BundlingInputs */

const cs_franchise_create_bundling = /** @type {(inputs: Franchise_Create_BundlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Způsob licencování`)
};

const en_franchise_create_bundling = /** @type {(inputs: Franchise_Create_BundlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licensing`)
};

/**
* | output |
* | --- |
* | "Licensing" |
*
* @param {Franchise_Create_BundlingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_create_bundling = /** @type {((inputs?: Franchise_Create_BundlingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Create_BundlingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_create_bundling(inputs)
	return cs_franchise_create_bundling(inputs)
});